import { InretrnWidgetContent } from "./inreturn-widget-content";
import { getInreturnCredentials } from "../../../utils/get-inreturn-credentials";

export const InretrnWidget = () => {
  const { inretrnUrl, inretrnToken } = getInreturnCredentials();

  return (
    <InretrnWidgetContent
      scriptUrl={inretrnUrl}
      token={inretrnToken}
      returnType="return"
    />
  );
};
